import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const AboutUsSectionThunk = createAsyncThunk(
	'AboutUsSectionThunk',
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get(
				'https://api.act2hf.com/api/public/who_are_we',
			);

			return res?.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	},
);
